import { useEffect, useReducer, useRef } from 'react';

function useReducerWithMiddleWare(
  reducer,
  initialState,
  middleWares,
  sideEffects
) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const actionRef = useRef();

  function dispatchWithSideEffects(action) {
    actionRef.current = action;
    middleWares.forEach((fnc) => fnc(action, state));
    dispatch(action);
  }

  useEffect(() => {
    if (!actionRef.current) return;
    sideEffects.forEach((fnc) => fnc(actionRef.current, state));
  }, [state, sideEffects]);

  return [state, dispatchWithSideEffects];
}

export { useReducerWithMiddleWare };
